import { useEffect, useRef, useState } from 'react';

interface ProgressBarProps {
  currentValue: number;
  maxValue: number;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({
  currentValue,
  maxValue,
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const [width, setWidth] = useState<number>(0);
  useEffect(() => {
    if (ref?.current?.clientWidth)
      setWidth(ref?.current?.clientWidth * (currentValue / maxValue));
  }, [ref, currentValue]);
  return (
    <div className="progress-bar-container">
      <div className="progress-bar">
        <span
          className="current-progress"
          style={{
            width: width,
          }}
        ></span>
        <div className="bar" ref={ref}></div>
      </div>
      <div className="numerical-values">
        <span style={{ fontSize: 12 }}>
          {currentValue}/{maxValue}
        </span>
      </div>
    </div>
  );
};
